/// <reference path="./index.d.ts" />
/**
 * Size-optimized onnxruntime-web export with only WASM backend included.
 * This trick reduces the bundle size by 562Kb (132Kb gzipped) of JavaScript code.
 */

import { simd as detectSimdSupport } from "wasm-feature-detect"
import Wasm from "/node_modules/onnxruntime-web/dist/ort-wasm-simd.wasm?url"
import WasmNoSimd from "/node_modules/onnxruntime-web/dist/ort-wasm.wasm?url"

export { env, InferenceSession, Tensor, type Env } from "onnxruntime-web"

/**
 * Session options interface for ONNX inference sessions.
 */
interface SessionOptions {
  executionProviders?: readonly string[]
  enableCpuMemArena?: boolean
  enableMemPattern?: boolean
  graphOptimizationLevel?: "disabled" | "basic" | "extended" | "all"
  [key: string]: unknown
}

/**
 * Optimized ONNX session options to prevent memory arena issues.
 * Disables CPU memory arena to prevent infinite memory growth and OOM errors.
 */
export const getOptimizedSessionOptions = (baseOptions: Partial<SessionOptions> = {}) => ({
  ...baseOptions,
  enableCpuMemArena: false,
  enableMemPattern: false,
  graphOptimizationLevel: "basic" as const,
})

const isSimdSupported = await detectSimdSupport()

export const getONNXWasm = async () => {
  return {
    numThreads: 1,
    url: isSimdSupported ? Wasm : WasmNoSimd,
    name: isSimdSupported ? "ort-wasm-simd.wasm" : "ort-wasm.wasm",
    type: "application/wasm",
  }
}
